/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * CloudDrive API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActivePlansResponse,
  AuthLoginBody,
  AuthRefreshBody,
  AuthRefreshResponse,
  AuthRegisterBody,
  AuthTokens,
  AuthUser,
  BulkMoveFilesBody,
  BulkTrashFilesBody,
  ChangePasswordBody,
  CheckSharesBulkBody,
  CheckSharesBulkResponse,
  CreateFeedbackBody,
  CreateFeedbackResponse,
  CreateFolderBody,
  CreateShareBody,
  DeleteMeBody,
  DownloadFromShareParams,
  DownloadResponse,
  ErrorResponse,
  FeedbackListResponse,
  FileItem,
  FileListResponse,
  GiftStorageBody,
  HealthStatus,
  ListFilesParams,
  LockFolderBody,
  MigrationJobResponse,
  MigrationJobsResponse,
  MigrationOAuthConfigResponse,
  MigrationOAuthStartResponse,
  MobileLogsHealthResponse,
  MobileLogsListResponse,
  MySharesResponse,
  PaymentStatusResponse,
  PaymentsAvailableResponse,
  PaymentsInitBody,
  PaymentsInitResponse,
  PaymentsWebhookBody,
  PlansResponse,
  PostMobileLogsBody,
  PostMobileLogsResponse,
  SavedCardResponse,
  SearchFilesParams,
  SetAutoRenewBody,
  SetAutoRenewResponse,
  SetFolderFilterBody,
  ShareLink,
  SharedFileResponse,
  SharesForFileResponse,
  StartMigrationBody,
  StartMigrationResponse,
  StorageStats,
  SuccessResponse,
  UnlockFolderBody,
  UnlockFolderRemoveBody,
  UpdateFileBody,
  UpdateMeBody,
  UpdateMeResponse,
  UpgradePlanBody,
  UpgradePlanResponse,
  UploadFileBody,
  UserMeResponse,
  ZipCheckBody,
  ZipStartBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List files and folders
 */
export const getListFilesUrl = (params?: ListFilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/files?${stringifiedParams}`
    : `/api/files`;
};

export const listFiles = async (
  params?: ListFilesParams,
  options?: RequestInit,
): Promise<FileListResponse> => {
  return customFetch<FileListResponse>(getListFilesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListFilesQueryKey = (params?: ListFilesParams) => {
  return [`/api/files`, ...(params ? [params] : [])] as const;
};

export const getListFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFiles>>> = ({
    signal,
  }) => listFiles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFiles>>
>;
export type ListFilesQueryError = ErrorType<unknown>;

/**
 * @summary List files and folders
 */

export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new folder
 */
export const getCreateFolderUrl = () => {
  return `/api/files`;
};

export const createFolder = async (
  createFolderBody: CreateFolderBody,
  options?: RequestInit,
): Promise<FileItem> => {
  return customFetch<FileItem>(getCreateFolderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFolderBody),
  });
};

export const getCreateFolderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFolder>>,
    TError,
    { data: BodyType<CreateFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFolder>>,
  TError,
  { data: BodyType<CreateFolderBody> },
  TContext
> => {
  const mutationKey = ["createFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFolder>>,
    { data: BodyType<CreateFolderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFolder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFolder>>
>;
export type CreateFolderMutationBody = BodyType<CreateFolderBody>;
export type CreateFolderMutationError = ErrorType<unknown>;

/**
 * @summary Create a new folder
 */
export const useCreateFolder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFolder>>,
    TError,
    { data: BodyType<CreateFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFolder>>,
  TError,
  { data: BodyType<CreateFolderBody> },
  TContext
> => {
  return useMutation(getCreateFolderMutationOptions(options));
};

/**
 * @summary Upload a file
 */
export const getUploadFileUrl = () => {
  return `/api/files/upload`;
};

export const uploadFile = async (
  uploadFileBody: UploadFileBody,
  options?: RequestInit,
): Promise<FileItem> => {
  const formData = new FormData();
  formData.append(`file`, uploadFileBody.file);
  if (
    uploadFileBody.parentId !== undefined &&
    uploadFileBody.parentId !== null
  ) {
    formData.append(`parentId`, uploadFileBody.parentId);
  }

  return customFetch<FileItem>(getUploadFileUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: BodyType<UploadFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyType<UploadFileBody> },
  TContext
> => {
  const mutationKey = ["uploadFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { data: BodyType<UploadFileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;
export type UploadFileMutationBody = BodyType<UploadFileBody>;
export type UploadFileMutationError = ErrorType<unknown>;

/**
 * @summary Upload a file
 */
export const useUploadFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: BodyType<UploadFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyType<UploadFileBody> },
  TContext
> => {
  return useMutation(getUploadFileMutationOptions(options));
};

/**
 * @summary Get recently accessed files
 */
export const getGetRecentFilesUrl = () => {
  return `/api/files/recent`;
};

export const getRecentFiles = async (
  options?: RequestInit,
): Promise<FileListResponse> => {
  return customFetch<FileListResponse>(getGetRecentFilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentFilesQueryKey = () => {
  return [`/api/files/recent`] as const;
};

export const getGetRecentFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecentFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentFilesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentFiles>>> = ({
    signal,
  }) => getRecentFiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentFiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentFiles>>
>;
export type GetRecentFilesQueryError = ErrorType<unknown>;

/**
 * @summary Get recently accessed files
 */

export function useGetRecentFiles<
  TData = Awaited<ReturnType<typeof getRecentFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecentFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentFilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get starred/favorited files
 */
export const getGetStarredFilesUrl = () => {
  return `/api/files/starred`;
};

export const getStarredFiles = async (
  options?: RequestInit,
): Promise<FileListResponse> => {
  return customFetch<FileListResponse>(getGetStarredFilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStarredFilesQueryKey = () => {
  return [`/api/files/starred`] as const;
};

export const getGetStarredFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStarredFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStarredFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStarredFilesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStarredFiles>>> = ({
    signal,
  }) => getStarredFiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStarredFiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStarredFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStarredFiles>>
>;
export type GetStarredFilesQueryError = ErrorType<unknown>;

/**
 * @summary Get starred/favorited files
 */

export function useGetStarredFiles<
  TData = Awaited<ReturnType<typeof getStarredFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStarredFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStarredFilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get trashed files
 */
export const getGetTrashFilesUrl = () => {
  return `/api/files/trash`;
};

export const getTrashFiles = async (
  options?: RequestInit,
): Promise<FileListResponse> => {
  return customFetch<FileListResponse>(getGetTrashFilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTrashFilesQueryKey = () => {
  return [`/api/files/trash`] as const;
};

export const getGetTrashFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrashFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrashFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrashFilesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrashFiles>>> = ({
    signal,
  }) => getTrashFiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrashFiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrashFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrashFiles>>
>;
export type GetTrashFilesQueryError = ErrorType<unknown>;

/**
 * @summary Get trashed files
 */

export function useGetTrashFiles<
  TData = Awaited<ReturnType<typeof getTrashFiles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTrashFiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrashFilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get file details
 */
export const getGetFileUrl = (id: string) => {
  return `/api/files/${id}`;
};

export const getFile = async (
  id: string,
  options?: RequestInit,
): Promise<FileItem> => {
  return customFetch<FileItem>(getGetFileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFileQueryKey = (id: string) => {
  return [`/api/files/${id}`] as const;
};

export const getGetFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFile>>> = ({
    signal,
  }) => getFile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFile>>
>;
export type GetFileQueryError = ErrorType<void>;

/**
 * @summary Get file details
 */

export function useGetFile<
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update file (rename, move, star, trash)
 */
export const getUpdateFileUrl = (id: string) => {
  return `/api/files/${id}`;
};

export const updateFile = async (
  id: string,
  updateFileBody: UpdateFileBody,
  options?: RequestInit,
): Promise<FileItem> => {
  return customFetch<FileItem>(getUpdateFileUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFileBody),
  });
};

export const getUpdateFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFile>>,
    TError,
    { id: string; data: BodyType<UpdateFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFile>>,
  TError,
  { id: string; data: BodyType<UpdateFileBody> },
  TContext
> => {
  const mutationKey = ["updateFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFile>>,
    { id: string; data: BodyType<UpdateFileBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFile>>
>;
export type UpdateFileMutationBody = BodyType<UpdateFileBody>;
export type UpdateFileMutationError = ErrorType<unknown>;

/**
 * @summary Update file (rename, move, star, trash)
 */
export const useUpdateFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFile>>,
    TError,
    { id: string; data: BodyType<UpdateFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFile>>,
  TError,
  { id: string; data: BodyType<UpdateFileBody> },
  TContext
> => {
  return useMutation(getUpdateFileMutationOptions(options));
};

/**
 * @summary Permanently delete file
 */
export const getDeleteFileUrl = (id: string) => {
  return `/api/files/${id}`;
};

export const deleteFile = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteFileUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFile>>
>;

export type DeleteFileMutationError = ErrorType<unknown>;

/**
 * @summary Permanently delete file
 */
export const useDeleteFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteFileMutationOptions(options));
};

/**
 * @summary Get download URL for a file
 */
export const getDownloadFileUrl = (id: string) => {
  return `/api/files/${id}/download`;
};

export const downloadFile = async (
  id: string,
  options?: RequestInit,
): Promise<DownloadResponse> => {
  return customFetch<DownloadResponse>(getDownloadFileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadFileQueryKey = (id: string) => {
  return [`/api/files/${id}/download`] as const;
};

export const getDownloadFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({
    signal,
  }) => downloadFile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFile>>
>;
export type DownloadFileQueryError = ErrorType<unknown>;

/**
 * @summary Get download URL for a file
 */

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadFileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Restore file from trash
 */
export const getRestoreFileUrl = (id: string) => {
  return `/api/files/${id}/restore`;
};

export const restoreFile = async (
  id: string,
  options?: RequestInit,
): Promise<FileItem> => {
  return customFetch<FileItem>(getRestoreFileUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreFile>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["restoreFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreFile>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return restoreFile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreFile>>
>;

export type RestoreFileMutationError = ErrorType<unknown>;

/**
 * @summary Restore file from trash
 */
export const useRestoreFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreFile>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRestoreFileMutationOptions(options));
};

/**
 * @summary Get storage usage statistics
 */
export const getGetStorageStatsUrl = () => {
  return `/api/storage/stats`;
};

export const getStorageStats = async (
  options?: RequestInit,
): Promise<StorageStats> => {
  return customFetch<StorageStats>(getGetStorageStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageStatsQueryKey = () => {
  return [`/api/storage/stats`] as const;
};

export const getGetStorageStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStorageStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorageStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageStats>>> = ({
    signal,
  }) => getStorageStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageStats>>
>;
export type GetStorageStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get storage usage statistics
 */

export function useGetStorageStats<
  TData = Awaited<ReturnType<typeof getStorageStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStorageStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Search files and folders
 */
export const getSearchFilesUrl = (params: SearchFilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/search?${stringifiedParams}`
    : `/api/search`;
};

export const searchFiles = async (
  params: SearchFilesParams,
  options?: RequestInit,
): Promise<FileListResponse> => {
  return customFetch<FileListResponse>(getSearchFilesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchFilesQueryKey = (params?: SearchFilesParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getSearchFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchFiles>>,
  TError = ErrorType<unknown>,
>(
  params: SearchFilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchFiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchFiles>>> = ({
    signal,
  }) => searchFiles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchFiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchFiles>>
>;
export type SearchFilesQueryError = ErrorType<unknown>;

/**
 * @summary Search files and folders
 */

export function useSearchFiles<
  TData = Awaited<ReturnType<typeof searchFiles>>,
  TError = ErrorType<unknown>,
>(
  params: SearchFilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchFiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Создать публичную ссылку (детальная схема ответа)
 */
export const getCreateShareUrl = () => {
  return `/api/s`;
};

export const createShare = async (
  createShareBody: CreateShareBody,
  options?: RequestInit,
): Promise<ShareLink> => {
  return customFetch<ShareLink>(getCreateShareUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createShareBody),
  });
};

export const getCreateShareMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShare>>,
    TError,
    { data: BodyType<CreateShareBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createShare>>,
  TError,
  { data: BodyType<CreateShareBody> },
  TContext
> => {
  const mutationKey = ["createShare"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createShare>>,
    { data: BodyType<CreateShareBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createShare(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof createShare>>
>;
export type CreateShareMutationBody = BodyType<CreateShareBody>;
export type CreateShareMutationError = ErrorType<unknown>;

/**
 * @summary Создать публичную ссылку (детальная схема ответа)
 */
export const useCreateShare = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShare>>,
    TError,
    { data: BodyType<CreateShareBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createShare>>,
  TError,
  { data: BodyType<CreateShareBody> },
  TContext
> => {
  return useMutation(getCreateShareMutationOptions(options));
};

/**
 * @summary Получить содержимое публичной ссылки
 */
export const getGetSharedFileUrl = (token: string) => {
  return `/api/s/${token}`;
};

export const getSharedFile = async (
  token: string,
  options?: RequestInit,
): Promise<SharedFileResponse> => {
  return customFetch<SharedFileResponse>(getGetSharedFileUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetSharedFileQueryKey = (token: string) => {
  return [`/api/s/${token}`] as const;
};

export const getGetSharedFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedFile>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSharedFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedFileQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedFile>>> = ({
    signal,
  }) => getSharedFile(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSharedFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedFile>>
>;
export type GetSharedFileQueryError = ErrorType<unknown>;

/**
 * @summary Получить содержимое публичной ссылки
 */

export function useGetSharedFile<
  TData = Awaited<ReturnType<typeof getSharedFile>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSharedFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSharedFileQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Регистрация нового пользователя
 */
export const getAuthRegisterUrl = () => {
  return `/api/auth/register`;
};

export const authRegister = async (
  authRegisterBody: AuthRegisterBody,
  options?: RequestInit,
): Promise<AuthTokens> => {
  return customFetch<AuthTokens>(getAuthRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authRegisterBody),
  });
};

export const getAuthRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegister>>,
    TError,
    { data: BodyType<AuthRegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegister>>,
  TError,
  { data: BodyType<AuthRegisterBody> },
  TContext
> => {
  const mutationKey = ["authRegister"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRegister>>,
    { data: BodyType<AuthRegisterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authRegister(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegister>>
>;
export type AuthRegisterMutationBody = BodyType<AuthRegisterBody>;
export type AuthRegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Регистрация нового пользователя
 */
export const useAuthRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegister>>,
    TError,
    { data: BodyType<AuthRegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authRegister>>,
  TError,
  { data: BodyType<AuthRegisterBody> },
  TContext
> => {
  return useMutation(getAuthRegisterMutationOptions(options));
};

/**
 * @summary Вход по email и паролю
 */
export const getAuthLoginUrl = () => {
  return `/api/auth/login`;
};

export const authLogin = async (
  authLoginBody: AuthLoginBody,
  options?: RequestInit,
): Promise<AuthTokens> => {
  return customFetch<AuthTokens>(getAuthLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authLoginBody),
  });
};

export const getAuthLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogin>>,
    TError,
    { data: BodyType<AuthLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<AuthLoginBody> },
  TContext
> => {
  const mutationKey = ["authLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authLogin>>,
    { data: BodyType<AuthLoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authLogin>>
>;
export type AuthLoginMutationBody = BodyType<AuthLoginBody>;
export type AuthLoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Вход по email и паролю
 */
export const useAuthLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogin>>,
    TError,
    { data: BodyType<AuthLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<AuthLoginBody> },
  TContext
> => {
  return useMutation(getAuthLoginMutationOptions(options));
};

/**
 * @summary Обновить access-токен по refresh-токену
 */
export const getAuthRefreshUrl = () => {
  return `/api/auth/refresh`;
};

export const authRefresh = async (
  authRefreshBody: AuthRefreshBody,
  options?: RequestInit,
): Promise<AuthRefreshResponse> => {
  return customFetch<AuthRefreshResponse>(getAuthRefreshUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authRefreshBody),
  });
};

export const getAuthRefreshMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRefresh>>,
    TError,
    { data: BodyType<AuthRefreshBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRefresh>>,
  TError,
  { data: BodyType<AuthRefreshBody> },
  TContext
> => {
  const mutationKey = ["authRefresh"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRefresh>>,
    { data: BodyType<AuthRefreshBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRefresh>>
>;
export type AuthRefreshMutationBody = BodyType<AuthRefreshBody>;
export type AuthRefreshMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Обновить access-токен по refresh-токену
 */
export const useAuthRefresh = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRefresh>>,
    TError,
    { data: BodyType<AuthRefreshBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authRefresh>>,
  TError,
  { data: BodyType<AuthRefreshBody> },
  TContext
> => {
  return useMutation(getAuthRefreshMutationOptions(options));
};

/**
 * @summary Текущий пользователь по access-токену
 */
export const getAuthMeUrl = () => {
  return `/api/auth/me`;
};

export const authMe = async (options?: RequestInit): Promise<AuthUser> => {
  return customFetch<AuthUser>(getAuthMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAuthMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof authMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({
    signal,
  }) => authMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>;
export type AuthMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Текущий пользователь по access-токену
 */

export function useAuthMe<
  TData = Awaited<ReturnType<typeof authMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAuthMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Профиль с детальной информацией о квоте
 */
export const getGetMeUrl = () => {
  return `/api/users/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserMeResponse> => {
  return customFetch<UserMeResponse>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/users/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<unknown>;

/**
 * @summary Профиль с детальной информацией о квоте
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Изменить имя пользователя
 */
export const getUpdateMeUrl = () => {
  return `/api/users/me`;
};

export const updateMe = async (
  updateMeBody: UpdateMeBody,
  options?: RequestInit,
): Promise<UpdateMeResponse> => {
  return customFetch<UpdateMeResponse>(getUpdateMeUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMeBody),
  });
};

export const getUpdateMeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateMeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateMeBody> },
  TContext
> => {
  const mutationKey = ["updateMe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMe>>,
    { data: BodyType<UpdateMeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMe>>
>;
export type UpdateMeMutationBody = BodyType<UpdateMeBody>;
export type UpdateMeMutationError = ErrorType<unknown>;

/**
 * @summary Изменить имя пользователя
 */
export const useUpdateMe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateMeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateMeBody> },
  TContext
> => {
  return useMutation(getUpdateMeMutationOptions(options));
};

/**
 * @summary Удалить аккаунт (требует подтверждения паролем)
 */
export const getDeleteMeUrl = () => {
  return `/api/users/me`;
};

export const deleteMe = async (
  deleteMeBody: DeleteMeBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteMeUrl(), {
    ...options,
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteMeBody),
  });
};

export const getDeleteMeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMe>>,
    TError,
    { data: BodyType<DeleteMeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMe>>,
  TError,
  { data: BodyType<DeleteMeBody> },
  TContext
> => {
  const mutationKey = ["deleteMe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMe>>,
    { data: BodyType<DeleteMeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMe>>
>;
export type DeleteMeMutationBody = BodyType<DeleteMeBody>;
export type DeleteMeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Удалить аккаунт (требует подтверждения паролем)
 */
export const useDeleteMe = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMe>>,
    TError,
    { data: BodyType<DeleteMeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMe>>,
  TError,
  { data: BodyType<DeleteMeBody> },
  TContext
> => {
  return useMutation(getDeleteMeMutationOptions(options));
};

/**
 * @summary Сменить пароль
 */
export const getChangePasswordUrl = () => {
  return `/api/users/me/password`;
};

export const changePassword = async (
  changePasswordBody: ChangePasswordBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getChangePasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordBody),
  });
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordBody> },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: BodyType<ChangePasswordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = BodyType<ChangePasswordBody>;
export type ChangePasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Сменить пароль
 */
export const useChangePassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordBody> },
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options));
};

/**
 * @summary Список тарифов (статичный fallback)
 */
export const getGetPlansFallbackUrl = () => {
  return `/api/users/plans`;
};

export const getPlansFallback = async (
  options?: RequestInit,
): Promise<PlansResponse> => {
  return customFetch<PlansResponse>(getGetPlansFallbackUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlansFallbackQueryKey = () => {
  return [`/api/users/plans`] as const;
};

export const getGetPlansFallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlansFallback>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlansFallback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlansFallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlansFallback>>
  > = ({ signal }) => getPlansFallback({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlansFallback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlansFallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlansFallback>>
>;
export type GetPlansFallbackQueryError = ErrorType<unknown>;

/**
 * @summary Список тарифов (статичный fallback)
 */

export function useGetPlansFallback<
  TData = Awaited<ReturnType<typeof getPlansFallback>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlansFallback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlansFallbackQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Перейти на бесплатный тариф (платные — через `/payments/init`)
 */
export const getUpgradePlanUrl = () => {
  return `/api/users/upgrade`;
};

export const upgradePlan = async (
  upgradePlanBody: UpgradePlanBody,
  options?: RequestInit,
): Promise<UpgradePlanResponse> => {
  return customFetch<UpgradePlanResponse>(getUpgradePlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upgradePlanBody),
  });
};

export const getUpgradePlanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  const mutationKey = ["upgradePlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradePlan>>,
    { data: BodyType<UpgradePlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upgradePlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradePlan>>
>;
export type UpgradePlanMutationBody = BodyType<UpgradePlanBody>;
export type UpgradePlanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Перейти на бесплатный тариф (платные — через `/payments/init`)
 */
export const useUpgradePlan = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  return useMutation(getUpgradePlanMutationOptions(options));
};

/**
 * @summary Плоский список всех папок пользователя
 */
export const getListAllFoldersUrl = () => {
  return `/api/files/all-folders`;
};

export const listAllFolders = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getListAllFoldersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAllFoldersQueryKey = () => {
  return [`/api/files/all-folders`] as const;
};

export const getListAllFoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllFolders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllFolders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllFoldersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllFolders>>> = ({
    signal,
  }) => listAllFolders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllFolders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllFoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllFolders>>
>;
export type ListAllFoldersQueryError = ErrorType<unknown>;

/**
 * @summary Плоский список всех папок пользователя
 */

export function useListAllFolders<
  TData = Awaited<ReturnType<typeof listAllFolders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAllFolders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllFoldersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Цепочка родительских папок
 */
export const getGetFileAncestorsUrl = (id: string) => {
  return `/api/files/ancestors/${id}`;
};

export const getFileAncestors = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetFileAncestorsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFileAncestorsQueryKey = (id: string) => {
  return [`/api/files/ancestors/${id}`] as const;
};

export const getGetFileAncestorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileAncestors>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFileAncestors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFileAncestorsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFileAncestors>>
  > = ({ signal }) => getFileAncestors(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileAncestors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFileAncestorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileAncestors>>
>;
export type GetFileAncestorsQueryError = ErrorType<unknown>;

/**
 * @summary Цепочка родительских папок
 */

export function useGetFileAncestors<
  TData = Awaited<ReturnType<typeof getFileAncestors>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFileAncestors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFileAncestorsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Группы дубликатов (по имени и размеру)
 */
export const getListDuplicatesUrl = () => {
  return `/api/files/duplicates`;
};

export const listDuplicates = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getListDuplicatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDuplicatesQueryKey = () => {
  return [`/api/files/duplicates`] as const;
};

export const getListDuplicatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDuplicates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDuplicates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDuplicatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDuplicates>>> = ({
    signal,
  }) => listDuplicates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDuplicates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDuplicatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDuplicates>>
>;
export type ListDuplicatesQueryError = ErrorType<unknown>;

/**
 * @summary Группы дубликатов (по имени и размеру)
 */

export function useListDuplicates<
  TData = Awaited<ReturnType<typeof listDuplicates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDuplicates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDuplicatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Массовое перемещение файлов в папку
 */
export const getBulkMoveFilesUrl = () => {
  return `/api/files/bulk-move`;
};

export const bulkMoveFiles = async (
  bulkMoveFilesBody: BulkMoveFilesBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getBulkMoveFilesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkMoveFilesBody),
  });
};

export const getBulkMoveFilesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkMoveFiles>>,
    TError,
    { data: BodyType<BulkMoveFilesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkMoveFiles>>,
  TError,
  { data: BodyType<BulkMoveFilesBody> },
  TContext
> => {
  const mutationKey = ["bulkMoveFiles"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkMoveFiles>>,
    { data: BodyType<BulkMoveFilesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkMoveFiles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkMoveFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkMoveFiles>>
>;
export type BulkMoveFilesMutationBody = BodyType<BulkMoveFilesBody>;
export type BulkMoveFilesMutationError = ErrorType<unknown>;

/**
 * @summary Массовое перемещение файлов в папку
 */
export const useBulkMoveFiles = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkMoveFiles>>,
    TError,
    { data: BodyType<BulkMoveFilesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkMoveFiles>>,
  TError,
  { data: BodyType<BulkMoveFilesBody> },
  TContext
> => {
  return useMutation(getBulkMoveFilesMutationOptions(options));
};

/**
 * @summary Массовое перемещение файлов в корзину
 */
export const getBulkTrashFilesUrl = () => {
  return `/api/files/bulk-trash`;
};

export const bulkTrashFiles = async (
  bulkTrashFilesBody: BulkTrashFilesBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getBulkTrashFilesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkTrashFilesBody),
  });
};

export const getBulkTrashFilesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkTrashFiles>>,
    TError,
    { data: BodyType<BulkTrashFilesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkTrashFiles>>,
  TError,
  { data: BodyType<BulkTrashFilesBody> },
  TContext
> => {
  const mutationKey = ["bulkTrashFiles"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkTrashFiles>>,
    { data: BodyType<BulkTrashFilesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkTrashFiles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkTrashFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkTrashFiles>>
>;
export type BulkTrashFilesMutationBody = BodyType<BulkTrashFilesBody>;
export type BulkTrashFilesMutationError = ErrorType<unknown>;

/**
 * @summary Массовое перемещение файлов в корзину
 */
export const useBulkTrashFiles = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkTrashFiles>>,
    TError,
    { data: BodyType<BulkTrashFilesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkTrashFiles>>,
  TError,
  { data: BodyType<BulkTrashFilesBody> },
  TContext
> => {
  return useMutation(getBulkTrashFilesMutationOptions(options));
};

/**
 * @summary Бинарный поток файла (inline) для предпросмотра
 */
export const getStreamFileContentUrl = (id: string) => {
  return `/api/files/${id}/content`;
};

export const streamFileContent = async (
  id: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getStreamFileContentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getStreamFileContentQueryKey = (id: string) => {
  return [`/api/files/${id}/content`] as const;
};

export const getStreamFileContentQueryOptions = <
  TData = Awaited<ReturnType<typeof streamFileContent>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof streamFileContent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamFileContentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof streamFileContent>>
  > = ({ signal }) => streamFileContent(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof streamFileContent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StreamFileContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamFileContent>>
>;
export type StreamFileContentQueryError = ErrorType<void>;

/**
 * @summary Бинарный поток файла (inline) для предпросмотра
 */

export function useStreamFileContent<
  TData = Awaited<ReturnType<typeof streamFileContent>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof streamFileContent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStreamFileContentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Превью изображения
 */
export const getGetFileThumbnailUrl = (id: string) => {
  return `/api/files/${id}/thumbnail`;
};

export const getFileThumbnail = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetFileThumbnailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFileThumbnailQueryKey = (id: string) => {
  return [`/api/files/${id}/thumbnail`] as const;
};

export const getGetFileThumbnailQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileThumbnail>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFileThumbnail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFileThumbnailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFileThumbnail>>
  > = ({ signal }) => getFileThumbnail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileThumbnail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFileThumbnailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileThumbnail>>
>;
export type GetFileThumbnailQueryError = ErrorType<unknown>;

/**
 * @summary Превью изображения
 */

export function useGetFileThumbnail<
  TData = Awaited<ReturnType<typeof getFileThumbnail>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFileThumbnail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFileThumbnailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Заранее проверить, есть ли в выборке защищённые подпапки
 */
export const getZipCheckUrl = () => {
  return `/api/files/zip/check`;
};

export const zipCheck = async (
  zipCheckBody: ZipCheckBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getZipCheckUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(zipCheckBody),
  });
};

export const getZipCheckMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zipCheck>>,
    TError,
    { data: BodyType<ZipCheckBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof zipCheck>>,
  TError,
  { data: BodyType<ZipCheckBody> },
  TContext
> => {
  const mutationKey = ["zipCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof zipCheck>>,
    { data: BodyType<ZipCheckBody> }
  > = (props) => {
    const { data } = props ?? {};

    return zipCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ZipCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof zipCheck>>
>;
export type ZipCheckMutationBody = BodyType<ZipCheckBody>;
export type ZipCheckMutationError = ErrorType<unknown>;

/**
 * @summary Заранее проверить, есть ли в выборке защищённые подпапки
 */
export const useZipCheck = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zipCheck>>,
    TError,
    { data: BodyType<ZipCheckBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof zipCheck>>,
  TError,
  { data: BodyType<ZipCheckBody> },
  TContext
> => {
  return useMutation(getZipCheckMutationOptions(options));
};

/**
 * @summary Запустить подготовку ZIP-архива
 */
export const getZipStartUrl = () => {
  return `/api/files/zip`;
};

export const zipStart = async (
  zipStartBody: ZipStartBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getZipStartUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(zipStartBody),
  });
};

export const getZipStartMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zipStart>>,
    TError,
    { data: BodyType<ZipStartBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof zipStart>>,
  TError,
  { data: BodyType<ZipStartBody> },
  TContext
> => {
  const mutationKey = ["zipStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof zipStart>>,
    { data: BodyType<ZipStartBody> }
  > = (props) => {
    const { data } = props ?? {};

    return zipStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ZipStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof zipStart>>
>;
export type ZipStartMutationBody = BodyType<ZipStartBody>;
export type ZipStartMutationError = ErrorType<void>;

/**
 * @summary Запустить подготовку ZIP-архива
 */
export const useZipStart = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof zipStart>>,
    TError,
    { data: BodyType<ZipStartBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof zipStart>>,
  TError,
  { data: BodyType<ZipStartBody> },
  TContext
> => {
  return useMutation(getZipStartMutationOptions(options));
};

/**
 * @summary Прогресс подготовки архива
 */
export const getZipProgressUrl = (jobId: string) => {
  return `/api/files/zip/${jobId}/progress`;
};

export const zipProgress = async (
  jobId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getZipProgressUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getZipProgressQueryKey = (jobId: string) => {
  return [`/api/files/zip/${jobId}/progress`] as const;
};

export const getZipProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof zipProgress>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipProgress>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getZipProgressQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof zipProgress>>> = ({
    signal,
  }) => zipProgress(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof zipProgress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ZipProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof zipProgress>>
>;
export type ZipProgressQueryError = ErrorType<unknown>;

/**
 * @summary Прогресс подготовки архива
 */

export function useZipProgress<
  TData = Awaited<ReturnType<typeof zipProgress>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipProgress>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getZipProgressQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Прогресс подготовки архива в виде Server-Sent Events
 */
export const getZipProgressStreamUrl = (jobId: string) => {
  return `/api/files/zip/${jobId}/stream`;
};

export const zipProgressStream = async (
  jobId: string,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getZipProgressStreamUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getZipProgressStreamQueryKey = (jobId: string) => {
  return [`/api/files/zip/${jobId}/stream`] as const;
};

export const getZipProgressStreamQueryOptions = <
  TData = Awaited<ReturnType<typeof zipProgressStream>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipProgressStream>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getZipProgressStreamQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof zipProgressStream>>
  > = ({ signal }) => zipProgressStream(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof zipProgressStream>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ZipProgressStreamQueryResult = NonNullable<
  Awaited<ReturnType<typeof zipProgressStream>>
>;
export type ZipProgressStreamQueryError = ErrorType<unknown>;

/**
 * @summary Прогресс подготовки архива в виде Server-Sent Events
 */

export function useZipProgressStream<
  TData = Awaited<ReturnType<typeof zipProgressStream>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipProgressStream>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getZipProgressStreamQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Скачать готовый ZIP-архив
 */
export const getZipDownloadUrl = (jobId: string) => {
  return `/api/files/zip/${jobId}/download`;
};

export const zipDownload = async (
  jobId: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getZipDownloadUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getZipDownloadQueryKey = (jobId: string) => {
  return [`/api/files/zip/${jobId}/download`] as const;
};

export const getZipDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof zipDownload>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getZipDownloadQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof zipDownload>>> = ({
    signal,
  }) => zipDownload(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof zipDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ZipDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof zipDownload>>
>;
export type ZipDownloadQueryError = ErrorType<unknown>;

/**
 * @summary Скачать готовый ZIP-архив
 */

export function useZipDownload<
  TData = Awaited<ReturnType<typeof zipDownload>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof zipDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getZipDownloadQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Установить пароль на папку
 */
export const getLockFolderUrl = (id: string) => {
  return `/api/files/${id}/lock`;
};

export const lockFolder = async (
  id: string,
  lockFolderBody: LockFolderBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getLockFolderUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(lockFolderBody),
  });
};

export const getLockFolderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockFolder>>,
    TError,
    { id: string; data: BodyType<LockFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockFolder>>,
  TError,
  { id: string; data: BodyType<LockFolderBody> },
  TContext
> => {
  const mutationKey = ["lockFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockFolder>>,
    { id: string; data: BodyType<LockFolderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return lockFolder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LockFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockFolder>>
>;
export type LockFolderMutationBody = BodyType<LockFolderBody>;
export type LockFolderMutationError = ErrorType<unknown>;

/**
 * @summary Установить пароль на папку
 */
export const useLockFolder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockFolder>>,
    TError,
    { id: string; data: BodyType<LockFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lockFolder>>,
  TError,
  { id: string; data: BodyType<LockFolderBody> },
  TContext
> => {
  return useMutation(getLockFolderMutationOptions(options));
};

/**
 * @summary Снять пароль с папки
 */
export const getUnlockFolderRemoveUrl = (id: string) => {
  return `/api/files/${id}/lock`;
};

export const unlockFolderRemove = async (
  id: string,
  unlockFolderRemoveBody: UnlockFolderRemoveBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getUnlockFolderRemoveUrl(id), {
    ...options,
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(unlockFolderRemoveBody),
  });
};

export const getUnlockFolderRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockFolderRemove>>,
    TError,
    { id: string; data: BodyType<UnlockFolderRemoveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockFolderRemove>>,
  TError,
  { id: string; data: BodyType<UnlockFolderRemoveBody> },
  TContext
> => {
  const mutationKey = ["unlockFolderRemove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockFolderRemove>>,
    { id: string; data: BodyType<UnlockFolderRemoveBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return unlockFolderRemove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockFolderRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockFolderRemove>>
>;
export type UnlockFolderRemoveMutationBody = BodyType<UnlockFolderRemoveBody>;
export type UnlockFolderRemoveMutationError = ErrorType<unknown>;

/**
 * @summary Снять пароль с папки
 */
export const useUnlockFolderRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockFolderRemove>>,
    TError,
    { id: string; data: BodyType<UnlockFolderRemoveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlockFolderRemove>>,
  TError,
  { id: string; data: BodyType<UnlockFolderRemoveBody> },
  TContext
> => {
  return useMutation(getUnlockFolderRemoveMutationOptions(options));
};

/**
 * @summary Получить unlock-токен (действует 2 часа)
 */
export const getUnlockFolderUrl = (id: string) => {
  return `/api/files/${id}/unlock`;
};

export const unlockFolder = async (
  id: string,
  unlockFolderBody: UnlockFolderBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getUnlockFolderUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(unlockFolderBody),
  });
};

export const getUnlockFolderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockFolder>>,
    TError,
    { id: string; data: BodyType<UnlockFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockFolder>>,
  TError,
  { id: string; data: BodyType<UnlockFolderBody> },
  TContext
> => {
  const mutationKey = ["unlockFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockFolder>>,
    { id: string; data: BodyType<UnlockFolderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return unlockFolder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockFolder>>
>;
export type UnlockFolderMutationBody = BodyType<UnlockFolderBody>;
export type UnlockFolderMutationError = ErrorType<void>;

/**
 * @summary Получить unlock-токен (действует 2 часа)
 */
export const useUnlockFolder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockFolder>>,
    TError,
    { id: string; data: BodyType<UnlockFolderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlockFolder>>,
  TError,
  { id: string; data: BodyType<UnlockFolderBody> },
  TContext
> => {
  return useMutation(getUnlockFolderMutationOptions(options));
};

/**
 * @summary Текущие настройки фильтра расширений в папке
 */
export const getGetFolderFilterUrl = (id: string) => {
  return `/api/files/${id}/filter`;
};

export const getFolderFilter = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetFolderFilterUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFolderFilterQueryKey = (id: string) => {
  return [`/api/files/${id}/filter`] as const;
};

export const getGetFolderFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getFolderFilter>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFolderFilter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFolderFilterQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolderFilter>>> = ({
    signal,
  }) => getFolderFilter(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFolderFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFolderFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFolderFilter>>
>;
export type GetFolderFilterQueryError = ErrorType<unknown>;

/**
 * @summary Текущие настройки фильтра расширений в папке
 */

export function useGetFolderFilter<
  TData = Awaited<ReturnType<typeof getFolderFilter>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFolderFilter>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFolderFilterQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Обновить фильтр расширений и режим flat-upload
 */
export const getSetFolderFilterUrl = (id: string) => {
  return `/api/files/${id}/filter`;
};

export const setFolderFilter = async (
  id: string,
  setFolderFilterBody: SetFolderFilterBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getSetFolderFilterUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setFolderFilterBody),
  });
};

export const getSetFolderFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setFolderFilter>>,
    TError,
    { id: string; data: BodyType<SetFolderFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setFolderFilter>>,
  TError,
  { id: string; data: BodyType<SetFolderFilterBody> },
  TContext
> => {
  const mutationKey = ["setFolderFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setFolderFilter>>,
    { id: string; data: BodyType<SetFolderFilterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setFolderFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetFolderFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof setFolderFilter>>
>;
export type SetFolderFilterMutationBody = BodyType<SetFolderFilterBody>;
export type SetFolderFilterMutationError = ErrorType<unknown>;

/**
 * @summary Обновить фильтр расширений и режим flat-upload
 */
export const useSetFolderFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setFolderFilter>>,
    TError,
    { id: string; data: BodyType<SetFolderFilterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setFolderFilter>>,
  TError,
  { id: string; data: BodyType<SetFolderFilterBody> },
  TContext
> => {
  return useMutation(getSetFolderFilterMutationOptions(options));
};

/**
 * @summary Войти в подпапку расшаренной папки
 */
export const getGetShareFolderUrl = (token: string, folderId: string) => {
  return `/api/s/${token}/folder/${folderId}`;
};

export const getShareFolder = async (
  token: string,
  folderId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetShareFolderUrl(token, folderId), {
    ...options,
    method: "GET",
  });
};

export const getGetShareFolderQueryKey = (token: string, folderId: string) => {
  return [`/api/s/${token}/folder/${folderId}`] as const;
};

export const getGetShareFolderQueryOptions = <
  TData = Awaited<ReturnType<typeof getShareFolder>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  folderId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShareFolder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetShareFolderQueryKey(token, folderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShareFolder>>> = ({
    signal,
  }) => getShareFolder(token, folderId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(token && folderId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShareFolder>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetShareFolderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShareFolder>>
>;
export type GetShareFolderQueryError = ErrorType<unknown>;

/**
 * @summary Войти в подпапку расшаренной папки
 */

export function useGetShareFolder<
  TData = Awaited<ReturnType<typeof getShareFolder>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  folderId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShareFolder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShareFolderQueryOptions(token, folderId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Скачать файл из публичной ссылки (бинарный поток)
 */
export const getDownloadFromShareUrl = (
  token: string,
  fileId: string,
  params?: DownloadFromShareParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/s/${token}/d/${fileId}?${stringifiedParams}`
    : `/api/s/${token}/d/${fileId}`;
};

export const downloadFromShare = async (
  token: string,
  fileId: string,
  params?: DownloadFromShareParams,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDownloadFromShareUrl(token, fileId, params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadFromShareQueryKey = (
  token: string,
  fileId: string,
  params?: DownloadFromShareParams,
) => {
  return [`/api/s/${token}/d/${fileId}`, ...(params ? [params] : [])] as const;
};

export const getDownloadFromShareQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFromShare>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  fileId: string,
  params?: DownloadFromShareParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadFromShare>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadFromShareQueryKey(token, fileId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadFromShare>>
  > = ({ signal }) =>
    downloadFromShare(token, fileId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(token && fileId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFromShare>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadFromShareQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFromShare>>
>;
export type DownloadFromShareQueryError = ErrorType<unknown>;

/**
 * @summary Скачать файл из публичной ссылки (бинарный поток)
 */

export function useDownloadFromShare<
  TData = Awaited<ReturnType<typeof downloadFromShare>>,
  TError = ErrorType<unknown>,
>(
  token: string,
  fileId: string,
  params?: DownloadFromShareParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadFromShare>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadFromShareQueryOptions(
    token,
    fileId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Карта `fileId → есть ли активная шара`
 */
export const getCheckSharesBulkUrl = () => {
  return `/api/shares/check-bulk`;
};

export const checkSharesBulk = async (
  checkSharesBulkBody: CheckSharesBulkBody,
  options?: RequestInit,
): Promise<CheckSharesBulkResponse> => {
  return customFetch<CheckSharesBulkResponse>(getCheckSharesBulkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(checkSharesBulkBody),
  });
};

export const getCheckSharesBulkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkSharesBulk>>,
    TError,
    { data: BodyType<CheckSharesBulkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkSharesBulk>>,
  TError,
  { data: BodyType<CheckSharesBulkBody> },
  TContext
> => {
  const mutationKey = ["checkSharesBulk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkSharesBulk>>,
    { data: BodyType<CheckSharesBulkBody> }
  > = (props) => {
    const { data } = props ?? {};

    return checkSharesBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckSharesBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkSharesBulk>>
>;
export type CheckSharesBulkMutationBody = BodyType<CheckSharesBulkBody>;
export type CheckSharesBulkMutationError = ErrorType<unknown>;

/**
 * @summary Карта `fileId → есть ли активная шара`
 */
export const useCheckSharesBulk = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkSharesBulk>>,
    TError,
    { data: BodyType<CheckSharesBulkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkSharesBulk>>,
  TError,
  { data: BodyType<CheckSharesBulkBody> },
  TContext
> => {
  return useMutation(getCheckSharesBulkMutationOptions(options));
};

/**
 * @summary Все мои активные шары на конкретный файл
 */
export const getGetSharesForFileUrl = (fileId: string) => {
  return `/api/shares/file/${fileId}`;
};

export const getSharesForFile = async (
  fileId: string,
  options?: RequestInit,
): Promise<SharesForFileResponse> => {
  return customFetch<SharesForFileResponse>(getGetSharesForFileUrl(fileId), {
    ...options,
    method: "GET",
  });
};

export const getGetSharesForFileQueryKey = (fileId: string) => {
  return [`/api/shares/file/${fileId}`] as const;
};

export const getGetSharesForFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharesForFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSharesForFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSharesForFileQueryKey(fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSharesForFile>>
  > = ({ signal }) => getSharesForFile(fileId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fileId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharesForFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSharesForFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharesForFile>>
>;
export type GetSharesForFileQueryError = ErrorType<unknown>;

/**
 * @summary Все мои активные шары на конкретный файл
 */

export function useGetSharesForFile<
  TData = Awaited<ReturnType<typeof getSharesForFile>>,
  TError = ErrorType<unknown>,
>(
  fileId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSharesForFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSharesForFileQueryOptions(fileId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Все мои активные публичные ссылки (плоский массив)
 */
export const getListMySharesUrl = () => {
  return `/api/shares/my`;
};

export const listMyShares = async (
  options?: RequestInit,
): Promise<MySharesResponse> => {
  return customFetch<MySharesResponse>(getListMySharesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMySharesQueryKey = () => {
  return [`/api/shares/my`] as const;
};

export const getListMySharesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyShares>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyShares>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMySharesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyShares>>> = ({
    signal,
  }) => listMyShares({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyShares>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMySharesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyShares>>
>;
export type ListMySharesQueryError = ErrorType<unknown>;

/**
 * @summary Все мои активные публичные ссылки (плоский массив)
 */

export function useListMyShares<
  TData = Awaited<ReturnType<typeof listMyShares>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyShares>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMySharesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Удалить публичную ссылку
 */
export const getDeleteShareUrl = (id: string) => {
  return `/api/shares/${id}`;
};

export const deleteShare = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteShareUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteShareMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShare>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteShare>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteShare"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteShare>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteShare(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteShare>>
>;

export type DeleteShareMutationError = ErrorType<unknown>;

/**
 * @summary Удалить публичную ссылку
 */
export const useDeleteShare = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShare>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteShare>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteShareMutationOptions(options));
};

/**
 * @summary Подарить место (1–10 000 ГБ)
 */
export const getGiftStorageUrl = () => {
  return `/api/storage/gift`;
};

export const giftStorage = async (
  giftStorageBody: GiftStorageBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGiftStorageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(giftStorageBody),
  });
};

export const getGiftStorageMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof giftStorage>>,
    TError,
    { data: BodyType<GiftStorageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof giftStorage>>,
  TError,
  { data: BodyType<GiftStorageBody> },
  TContext
> => {
  const mutationKey = ["giftStorage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof giftStorage>>,
    { data: BodyType<GiftStorageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return giftStorage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GiftStorageMutationResult = NonNullable<
  Awaited<ReturnType<typeof giftStorage>>
>;
export type GiftStorageMutationBody = BodyType<GiftStorageBody>;
export type GiftStorageMutationError = ErrorType<void>;

/**
 * @summary Подарить место (1–10 000 ГБ)
 */
export const useGiftStorage = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof giftStorage>>,
    TError,
    { data: BodyType<GiftStorageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof giftStorage>>,
  TError,
  { data: BodyType<GiftStorageBody> },
  TContext
> => {
  return useMutation(getGiftStorageMutationOptions(options));
};

/**
 * @summary Отозвать собственный подарок
 */
export const getRevokeStorageGiftUrl = (id: string) => {
  return `/api/storage/gift/${id}`;
};

export const revokeStorageGift = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRevokeStorageGiftUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeStorageGiftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeStorageGift>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeStorageGift>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["revokeStorageGift"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeStorageGift>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return revokeStorageGift(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeStorageGiftMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeStorageGift>>
>;

export type RevokeStorageGiftMutationError = ErrorType<unknown>;

/**
 * @summary Отозвать собственный подарок
 */
export const useRevokeStorageGift = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeStorageGift>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeStorageGift>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRevokeStorageGiftMutationOptions(options));
};

/**
 * @summary Сводка о подаренном/полученном месте, лимиты, кулдаун
 */
export const getGetStorageGiftsUrl = () => {
  return `/api/storage/gifts`;
};

export const getStorageGifts = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getGetStorageGiftsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageGiftsQueryKey = () => {
  return [`/api/storage/gifts`] as const;
};

export const getGetStorageGiftsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageGifts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStorageGifts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorageGiftsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageGifts>>> = ({
    signal,
  }) => getStorageGifts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageGifts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageGiftsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageGifts>>
>;
export type GetStorageGiftsQueryError = ErrorType<unknown>;

/**
 * @summary Сводка о подаренном/полученном месте, лимиты, кулдаун
 */

export function useGetStorageGifts<
  TData = Awaited<ReturnType<typeof getStorageGifts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStorageGifts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageGiftsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Активные тарифы для покупки (полные карточки с ценами и фичами)
 */
export const getGetActivePlansUrl = () => {
  return `/api/plans`;
};

export const getActivePlans = async (
  options?: RequestInit,
): Promise<ActivePlansResponse> => {
  return customFetch<ActivePlansResponse>(getGetActivePlansUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetActivePlansQueryKey = () => {
  return [`/api/plans`] as const;
};

export const getGetActivePlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivePlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActivePlans>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActivePlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivePlans>>> = ({
    signal,
  }) => getActivePlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivePlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivePlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivePlans>>
>;
export type GetActivePlansQueryError = ErrorType<unknown>;

/**
 * @summary Активные тарифы для покупки (полные карточки с ценами и фичами)
 */

export function useGetActivePlans<
  TData = Awaited<ReturnType<typeof getActivePlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActivePlans>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActivePlansQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Включён ли приём платежей
 */
export const getPaymentsAvailableUrl = () => {
  return `/api/payments/available`;
};

export const paymentsAvailable = async (
  options?: RequestInit,
): Promise<PaymentsAvailableResponse> => {
  return customFetch<PaymentsAvailableResponse>(getPaymentsAvailableUrl(), {
    ...options,
    method: "GET",
  });
};

export const getPaymentsAvailableQueryKey = () => {
  return [`/api/payments/available`] as const;
};

export const getPaymentsAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof paymentsAvailable>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPaymentsAvailableQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof paymentsAvailable>>
  > = ({ signal }) => paymentsAvailable({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentsAvailable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PaymentsAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentsAvailable>>
>;
export type PaymentsAvailableQueryError = ErrorType<unknown>;

/**
 * @summary Включён ли приём платежей
 */

export function usePaymentsAvailable<
  TData = Awaited<ReturnType<typeof paymentsAvailable>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof paymentsAvailable>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPaymentsAvailableQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Создать платёж и получить URL для редиректа
 */
export const getPaymentsInitUrl = () => {
  return `/api/payments/init`;
};

export const paymentsInit = async (
  paymentsInitBody: PaymentsInitBody,
  options?: RequestInit,
): Promise<PaymentsInitResponse> => {
  return customFetch<PaymentsInitResponse>(getPaymentsInitUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(paymentsInitBody),
  });
};

export const getPaymentsInitMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentsInit>>,
    TError,
    { data: BodyType<PaymentsInitBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentsInit>>,
  TError,
  { data: BodyType<PaymentsInitBody> },
  TContext
> => {
  const mutationKey = ["paymentsInit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentsInit>>,
    { data: BodyType<PaymentsInitBody> }
  > = (props) => {
    const { data } = props ?? {};

    return paymentsInit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PaymentsInitMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentsInit>>
>;
export type PaymentsInitMutationBody = BodyType<PaymentsInitBody>;
export type PaymentsInitMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Создать платёж и получить URL для редиректа
 */
export const usePaymentsInit = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentsInit>>,
    TError,
    { data: BodyType<PaymentsInitBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentsInit>>,
  TError,
  { data: BodyType<PaymentsInitBody> },
  TContext
> => {
  return useMutation(getPaymentsInitMutationOptions(options));
};

/**
 * @summary Webhook от T-Bank (см. рецепт подписи в основном документе)
 */
export const getPaymentsWebhookUrl = () => {
  return `/api/payments/webhook`;
};

export const paymentsWebhook = async (
  paymentsWebhookBody: PaymentsWebhookBody,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getPaymentsWebhookUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(paymentsWebhookBody),
  });
};

export const getPaymentsWebhookMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentsWebhook>>,
    TError,
    { data: BodyType<PaymentsWebhookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentsWebhook>>,
  TError,
  { data: BodyType<PaymentsWebhookBody> },
  TContext
> => {
  const mutationKey = ["paymentsWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentsWebhook>>,
    { data: BodyType<PaymentsWebhookBody> }
  > = (props) => {
    const { data } = props ?? {};

    return paymentsWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PaymentsWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentsWebhook>>
>;
export type PaymentsWebhookMutationBody = BodyType<PaymentsWebhookBody>;
export type PaymentsWebhookMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Webhook от T-Bank (см. рецепт подписи в основном документе)
 */
export const usePaymentsWebhook = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentsWebhook>>,
    TError,
    { data: BodyType<PaymentsWebhookBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentsWebhook>>,
  TError,
  { data: BodyType<PaymentsWebhookBody> },
  TContext
> => {
  return useMutation(getPaymentsWebhookMutationOptions(options));
};

/**
 * @summary Статус нашего платежа
 */
export const getPaymentsStatusUrl = (id: string) => {
  return `/api/payments/status/${id}`;
};

export const paymentsStatus = async (
  id: string,
  options?: RequestInit,
): Promise<PaymentStatusResponse> => {
  return customFetch<PaymentStatusResponse>(getPaymentsStatusUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getPaymentsStatusQueryKey = (id: string) => {
  return [`/api/payments/status/${id}`] as const;
};

export const getPaymentsStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentsStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof paymentsStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPaymentsStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentsStatus>>> = ({
    signal,
  }) => paymentsStatus(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentsStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PaymentsStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentsStatus>>
>;
export type PaymentsStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Статус нашего платежа
 */

export function usePaymentsStatus<
  TData = Awaited<ReturnType<typeof paymentsStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof paymentsStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPaymentsStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Сохранённая карта и состояние автопродления
 */
export const getGetSavedCardUrl = () => {
  return `/api/payments/saved-card`;
};

export const getSavedCard = async (
  options?: RequestInit,
): Promise<SavedCardResponse> => {
  return customFetch<SavedCardResponse>(getGetSavedCardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSavedCardQueryKey = () => {
  return [`/api/payments/saved-card`] as const;
};

export const getGetSavedCardQueryOptions = <
  TData = Awaited<ReturnType<typeof getSavedCard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSavedCard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSavedCardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedCard>>> = ({
    signal,
  }) => getSavedCard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSavedCard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSavedCardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSavedCard>>
>;
export type GetSavedCardQueryError = ErrorType<unknown>;

/**
 * @summary Сохранённая карта и состояние автопродления
 */

export function useGetSavedCard<
  TData = Awaited<ReturnType<typeof getSavedCard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSavedCard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSavedCardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Удалить сохранённую карту (выключает автопродление)
 */
export const getDeleteSavedCardUrl = () => {
  return `/api/payments/saved-card`;
};

export const deleteSavedCard = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteSavedCardUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSavedCardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedCard>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSavedCard>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteSavedCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSavedCard>>,
    void
  > = () => {
    return deleteSavedCard(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSavedCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSavedCard>>
>;

export type DeleteSavedCardMutationError = ErrorType<unknown>;

/**
 * @summary Удалить сохранённую карту (выключает автопродление)
 */
export const useDeleteSavedCard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedCard>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSavedCard>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteSavedCardMutationOptions(options));
};

/**
 * @summary Включить или выключить автопродление
 */
export const getSetAutoRenewUrl = () => {
  return `/api/payments/auto-renew`;
};

export const setAutoRenew = async (
  setAutoRenewBody: SetAutoRenewBody,
  options?: RequestInit,
): Promise<SetAutoRenewResponse> => {
  return customFetch<SetAutoRenewResponse>(getSetAutoRenewUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setAutoRenewBody),
  });
};

export const getSetAutoRenewMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutoRenew>>,
    TError,
    { data: BodyType<SetAutoRenewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutoRenew>>,
  TError,
  { data: BodyType<SetAutoRenewBody> },
  TContext
> => {
  const mutationKey = ["setAutoRenew"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutoRenew>>,
    { data: BodyType<SetAutoRenewBody> }
  > = (props) => {
    const { data } = props ?? {};

    return setAutoRenew(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutoRenewMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutoRenew>>
>;
export type SetAutoRenewMutationBody = BodyType<SetAutoRenewBody>;
export type SetAutoRenewMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Включить или выключить автопродление
 */
export const useSetAutoRenew = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutoRenew>>,
    TError,
    { data: BodyType<SetAutoRenewBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setAutoRenew>>,
  TError,
  { data: BodyType<SetAutoRenewBody> },
  TContext
> => {
  return useMutation(getSetAutoRenewMutationOptions(options));
};

/**
 * @summary Какие провайдеры подключены (Google Drive, Yandex, Mail.ru)
 */
export const getMigrationOAuthConfigUrl = () => {
  return `/api/migration/oauth/config`;
};

export const migrationOAuthConfig = async (
  options?: RequestInit,
): Promise<MigrationOAuthConfigResponse> => {
  return customFetch<MigrationOAuthConfigResponse>(
    getMigrationOAuthConfigUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMigrationOAuthConfigQueryKey = () => {
  return [`/api/migration/oauth/config`] as const;
};

export const getMigrationOAuthConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof migrationOAuthConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof migrationOAuthConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMigrationOAuthConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof migrationOAuthConfig>>
  > = ({ signal }) => migrationOAuthConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof migrationOAuthConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MigrationOAuthConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof migrationOAuthConfig>>
>;
export type MigrationOAuthConfigQueryError = ErrorType<unknown>;

/**
 * @summary Какие провайдеры подключены (Google Drive, Yandex, Mail.ru)
 */

export function useMigrationOAuthConfig<
  TData = Awaited<ReturnType<typeof migrationOAuthConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof migrationOAuthConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMigrationOAuthConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary URL для запуска OAuth у провайдера
 */
export const getMigrationOAuthStartUrl = (provider: string) => {
  return `/api/migration/oauth/start/${provider}`;
};

export const migrationOAuthStart = async (
  provider: string,
  options?: RequestInit,
): Promise<MigrationOAuthStartResponse> => {
  return customFetch<MigrationOAuthStartResponse>(
    getMigrationOAuthStartUrl(provider),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getMigrationOAuthStartQueryKey = (provider: string) => {
  return [`/api/migration/oauth/start/${provider}`] as const;
};

export const getMigrationOAuthStartQueryOptions = <
  TData = Awaited<ReturnType<typeof migrationOAuthStart>>,
  TError = ErrorType<ErrorResponse>,
>(
  provider: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof migrationOAuthStart>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMigrationOAuthStartQueryKey(provider);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof migrationOAuthStart>>
  > = ({ signal }) =>
    migrationOAuthStart(provider, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof migrationOAuthStart>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MigrationOAuthStartQueryResult = NonNullable<
  Awaited<ReturnType<typeof migrationOAuthStart>>
>;
export type MigrationOAuthStartQueryError = ErrorType<ErrorResponse>;

/**
 * @summary URL для запуска OAuth у провайдера
 */

export function useMigrationOAuthStart<
  TData = Awaited<ReturnType<typeof migrationOAuthStart>>,
  TError = ErrorType<ErrorResponse>,
>(
  provider: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof migrationOAuthStart>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMigrationOAuthStartQueryOptions(provider, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Колбэк после OAuth (вызывается провайдером)
 */
export const getMigrationOAuthCallbackUrl = (provider: string) => {
  return `/api/migration/oauth/callback/${provider}`;
};

export const migrationOAuthCallback = async (
  provider: string,
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getMigrationOAuthCallbackUrl(provider), {
    ...options,
    method: "GET",
  });
};

export const getMigrationOAuthCallbackQueryKey = (provider: string) => {
  return [`/api/migration/oauth/callback/${provider}`] as const;
};

export const getMigrationOAuthCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof migrationOAuthCallback>>,
  TError = ErrorType<void>,
>(
  provider: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof migrationOAuthCallback>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMigrationOAuthCallbackQueryKey(provider);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof migrationOAuthCallback>>
  > = ({ signal }) =>
    migrationOAuthCallback(provider, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof migrationOAuthCallback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MigrationOAuthCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof migrationOAuthCallback>>
>;
export type MigrationOAuthCallbackQueryError = ErrorType<void>;

/**
 * @summary Колбэк после OAuth (вызывается провайдером)
 */

export function useMigrationOAuthCallback<
  TData = Awaited<ReturnType<typeof migrationOAuthCallback>>,
  TError = ErrorType<void>,
>(
  provider: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof migrationOAuthCallback>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMigrationOAuthCallbackQueryOptions(provider, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Список задач переноса
 */
export const getListMigrationJobsUrl = () => {
  return `/api/migration/jobs`;
};

export const listMigrationJobs = async (
  options?: RequestInit,
): Promise<MigrationJobsResponse> => {
  return customFetch<MigrationJobsResponse>(getListMigrationJobsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMigrationJobsQueryKey = () => {
  return [`/api/migration/jobs`] as const;
};

export const getListMigrationJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMigrationJobs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMigrationJobs>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMigrationJobsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMigrationJobs>>
  > = ({ signal }) => listMigrationJobs({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMigrationJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMigrationJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMigrationJobs>>
>;
export type ListMigrationJobsQueryError = ErrorType<unknown>;

/**
 * @summary Список задач переноса
 */

export function useListMigrationJobs<
  TData = Awaited<ReturnType<typeof listMigrationJobs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMigrationJobs>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMigrationJobsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Статус задачи переноса
 */
export const getGetMigrationJobUrl = (id: string) => {
  return `/api/migration/jobs/${id}`;
};

export const getMigrationJob = async (
  id: string,
  options?: RequestInit,
): Promise<MigrationJobResponse> => {
  return customFetch<MigrationJobResponse>(getGetMigrationJobUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMigrationJobQueryKey = (id: string) => {
  return [`/api/migration/jobs/${id}`] as const;
};

export const getGetMigrationJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getMigrationJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMigrationJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMigrationJobQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMigrationJob>>> = ({
    signal,
  }) => getMigrationJob(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMigrationJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMigrationJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMigrationJob>>
>;
export type GetMigrationJobQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Статус задачи переноса
 */

export function useGetMigrationJob<
  TData = Awaited<ReturnType<typeof getMigrationJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMigrationJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMigrationJobQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Запустить перенос (multipart/form-data — `archive` или параметры провайдера)
 */
export const getStartMigrationUrl = () => {
  return `/api/migration/start`;
};

export const startMigration = async (
  startMigrationBody: StartMigrationBody,
  options?: RequestInit,
): Promise<StartMigrationResponse> => {
  const formData = new FormData();
  formData.append(`archive`, startMigrationBody.archive);
  formData.append(`provider`, startMigrationBody.provider);

  return customFetch<StartMigrationResponse>(getStartMigrationUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getStartMigrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMigration>>,
    TError,
    { data: BodyType<StartMigrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startMigration>>,
  TError,
  { data: BodyType<StartMigrationBody> },
  TContext
> => {
  const mutationKey = ["startMigration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startMigration>>,
    { data: BodyType<StartMigrationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return startMigration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartMigrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof startMigration>>
>;
export type StartMigrationMutationBody = BodyType<StartMigrationBody>;
export type StartMigrationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Запустить перенос (multipart/form-data — `archive` или параметры провайдера)
 */
export const useStartMigration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMigration>>,
    TError,
    { data: BodyType<StartMigrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startMigration>>,
  TError,
  { data: BodyType<StartMigrationBody> },
  TContext
> => {
  return useMutation(getStartMigrationMutationOptions(options));
};

/**
 * @summary Поставить задачу на паузу
 */
export const getPauseMigrationUrl = (id: string) => {
  return `/api/migration/jobs/${id}/pause`;
};

export const pauseMigration = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getPauseMigrationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPauseMigrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pauseMigration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["pauseMigration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseMigration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return pauseMigration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PauseMigrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof pauseMigration>>
>;

export type PauseMigrationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Поставить задачу на паузу
 */
export const usePauseMigration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof pauseMigration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPauseMigrationMutationOptions(options));
};

/**
 * @summary Возобновить задачу
 */
export const getResumeMigrationUrl = (id: string) => {
  return `/api/migration/jobs/${id}/resume`;
};

export const resumeMigration = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getResumeMigrationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResumeMigrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeMigration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["resumeMigration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeMigration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return resumeMigration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeMigrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeMigration>>
>;

export type ResumeMigrationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Возобновить задачу
 */
export const useResumeMigration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumeMigration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getResumeMigrationMutationOptions(options));
};

/**
 * @summary Отменить задачу
 */
export const getCancelMigrationUrl = (id: string) => {
  return `/api/migration/jobs/${id}/cancel`;
};

export const cancelMigration = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCancelMigrationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCancelMigrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMigration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelMigration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMigration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelMigration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMigrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMigration>>
>;

export type CancelMigrationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Отменить задачу
 */
export const useCancelMigration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMigration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMigration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelMigrationMutationOptions(options));
};

/**
 * @summary Отправить обратную связь
 */
export const getCreateFeedbackUrl = () => {
  return `/api/feedback`;
};

export const createFeedback = async (
  createFeedbackBody: CreateFeedbackBody,
  options?: RequestInit,
): Promise<CreateFeedbackResponse> => {
  return customFetch<CreateFeedbackResponse>(getCreateFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFeedbackBody),
  });
};

export const getCreateFeedbackMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedback>>,
    TError,
    { data: BodyType<CreateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeedback>>,
  TError,
  { data: BodyType<CreateFeedbackBody> },
  TContext
> => {
  const mutationKey = ["createFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeedback>>,
    { data: BodyType<CreateFeedbackBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeedback>>
>;
export type CreateFeedbackMutationBody = BodyType<CreateFeedbackBody>;
export type CreateFeedbackMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Отправить обратную связь
 */
export const useCreateFeedback = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedback>>,
    TError,
    { data: BodyType<CreateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFeedback>>,
  TError,
  { data: BodyType<CreateFeedbackBody> },
  TContext
> => {
  return useMutation(getCreateFeedbackMutationOptions(options));
};

/**
 * @summary Мои последние 50 заявок
 */
export const getListMyFeedbackUrl = () => {
  return `/api/feedback/my`;
};

export const listMyFeedback = async (
  options?: RequestInit,
): Promise<FeedbackListResponse> => {
  return customFetch<FeedbackListResponse>(getListMyFeedbackUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyFeedbackQueryKey = () => {
  return [`/api/feedback/my`] as const;
};

export const getListMyFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyFeedback>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyFeedback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyFeedbackQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyFeedback>>> = ({
    signal,
  }) => listMyFeedback({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyFeedback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyFeedback>>
>;
export type ListMyFeedbackQueryError = ErrorType<unknown>;

/**
 * @summary Мои последние 50 заявок
 */

export function useListMyFeedback<
  TData = Awaited<ReturnType<typeof listMyFeedback>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyFeedback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyFeedbackQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Доступно без авторизации (логи отправляет ещё не залогиненное приложение).
Если в заголовке `Authorization: Bearer …` есть валидный токен пользователя,
логи будут привязаны к нему.

 * @summary Пакетная отправка логов мобильного клиента (до 100 записей)
 */
export const getPostMobileLogsUrl = () => {
  return `/api/mobile-logs`;
};

export const postMobileLogs = async (
  postMobileLogsBody: PostMobileLogsBody,
  options?: RequestInit,
): Promise<PostMobileLogsResponse> => {
  return customFetch<PostMobileLogsResponse>(getPostMobileLogsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postMobileLogsBody),
  });
};

export const getPostMobileLogsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMobileLogs>>,
    TError,
    { data: BodyType<PostMobileLogsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMobileLogs>>,
  TError,
  { data: BodyType<PostMobileLogsBody> },
  TContext
> => {
  const mutationKey = ["postMobileLogs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMobileLogs>>,
    { data: BodyType<PostMobileLogsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postMobileLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMobileLogsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMobileLogs>>
>;
export type PostMobileLogsMutationBody = BodyType<PostMobileLogsBody>;
export type PostMobileLogsMutationError = ErrorType<unknown>;

/**
 * @summary Пакетная отправка логов мобильного клиента (до 100 записей)
 */
export const usePostMobileLogs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMobileLogs>>,
    TError,
    { data: BodyType<PostMobileLogsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postMobileLogs>>,
  TError,
  { data: BodyType<PostMobileLogsBody> },
  TContext
> => {
  return useMutation(getPostMobileLogsMutationOptions(options));
};

/**
 * Требует Bearer-токен администратора (см. `/admin/login`). Чувствительные
идентификаторы (`userId`, `deviceId`) маскируются, поле `message` обрезается до 500 символов.

 * @summary Последние 500 сохранённых логов (только для администратора)
 */
export const getGetMobileLogsUrl = () => {
  return `/api/mobile-logs`;
};

export const getMobileLogs = async (
  options?: RequestInit,
): Promise<MobileLogsListResponse> => {
  return customFetch<MobileLogsListResponse>(getGetMobileLogsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMobileLogsQueryKey = () => {
  return [`/api/mobile-logs`] as const;
};

export const getGetMobileLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobileLogs>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMobileLogs>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobileLogsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileLogs>>> = ({
    signal,
  }) => getMobileLogs({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobileLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMobileLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMobileLogs>>
>;
export type GetMobileLogsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Последние 500 сохранённых логов (только для администратора)
 */

export function useGetMobileLogs<
  TData = Awaited<ReturnType<typeof getMobileLogs>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMobileLogs>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMobileLogsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Простой health-чек для проверки доступности /mobile-logs (без авторизации)
 */
export const getMobileLogsHealthUrl = () => {
  return `/api/mobile-logs/health`;
};

export const mobileLogsHealth = async (
  options?: RequestInit,
): Promise<MobileLogsHealthResponse> => {
  return customFetch<MobileLogsHealthResponse>(getMobileLogsHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getMobileLogsHealthQueryKey = () => {
  return [`/api/mobile-logs/health`] as const;
};

export const getMobileLogsHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof mobileLogsHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mobileLogsHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMobileLogsHealthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mobileLogsHealth>>
  > = ({ signal }) => mobileLogsHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mobileLogsHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MobileLogsHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof mobileLogsHealth>>
>;
export type MobileLogsHealthQueryError = ErrorType<unknown>;

/**
 * @summary Простой health-чек для проверки доступности /mobile-logs (без авторизации)
 */

export function useMobileLogsHealth<
  TData = Awaited<ReturnType<typeof mobileLogsHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mobileLogsHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMobileLogsHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
